// extracted by mini-css-extract-plugin
export default {"container":"ba_mbF","containerBorderless":"S5Zqh9"};